import { render, staticRenderFns } from "./PaleCard.vue?vue&type=template&id=1791b801"
import script from "./PaleCard.vue?vue&type=script&lang=js"
export * from "./PaleCard.vue?vue&type=script&lang=js"
import style0 from "./PaleCard.vue?vue&type=style&index=0&id=1791b801&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports